// extracted by mini-css-extract-plugin
export default {"desktopSidebar":"root_shell-module__desktopSidebar___YstK1","mobileSidebarHeader":"root_shell-module__mobileSidebarHeader___uWJMW"};